import { LOGICAL_HEIGHT, LOGICAL_WIDTH } from './Renderer';

export type BackgroundId = 'dawn' | 'dusk' | 'cave' | 'crypt';

/** Draws an atmospheric gradient background, optionally with silhouette terrain. */
export function drawCombatBackground(
  ctx: CanvasRenderingContext2D,
  id: BackgroundId,
): void {
  switch (id) {
    case 'dawn':
      drawDawn(ctx);
      break;
    case 'dusk':
      drawDusk(ctx);
      break;
    case 'cave':
      drawCave(ctx);
      break;
    case 'crypt':
      drawCrypt(ctx);
      break;
  }
}

function drawDawn(ctx: CanvasRenderingContext2D): void {
  const sky = ctx.createLinearGradient(0, 0, 0, LOGICAL_HEIGHT);
  sky.addColorStop(0, '#1a1424');
  sky.addColorStop(0.45, '#5a2a2a');
  sky.addColorStop(0.75, '#c46838');
  sky.addColorStop(1, '#2a1610');
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
  // Sun disc.
  const grad = ctx.createRadialGradient(LOGICAL_WIDTH * 0.5, 360, 4, LOGICAL_WIDTH * 0.5, 360, 80);
  grad.addColorStop(0, 'rgba(255, 200, 100, 0.55)');
  grad.addColorStop(1, 'rgba(255, 200, 100, 0)');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
  drawHorizon(ctx, 470);
}

function drawDusk(ctx: CanvasRenderingContext2D): void {
  const sky = ctx.createLinearGradient(0, 0, 0, LOGICAL_HEIGHT);
  sky.addColorStop(0, '#0e0e1c');
  sky.addColorStop(0.5, '#322840');
  sky.addColorStop(0.85, '#5a3a52');
  sky.addColorStop(1, '#1a1018');
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
  drawHorizon(ctx, 470);
  // Distant trees.
  ctx.fillStyle = '#0a0608';
  for (let i = 0; i < 8; i++) {
    const x = i * 50 - 10;
    const h = 18 + (i % 3) * 8;
    ctx.beginPath();
    ctx.moveTo(x, 470);
    ctx.lineTo(x + 8, 470 - h);
    ctx.lineTo(x + 16, 470);
    ctx.closePath();
    ctx.fill();
  }
}

function drawCave(ctx: CanvasRenderingContext2D): void {
  ctx.fillStyle = '#1a1410';
  ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
  // Stalactites
  ctx.fillStyle = '#0a0806';
  for (let i = 0; i < 5; i++) {
    const x = 30 + i * 70;
    const h = 30 + (i * 13) % 30;
    ctx.beginPath();
    ctx.moveTo(x, 0);
    ctx.lineTo(x + 16, 0);
    ctx.lineTo(x + 8, h);
    ctx.closePath();
    ctx.fill();
  }
  // Floor.
  const floor = ctx.createLinearGradient(0, 440, 0, LOGICAL_HEIGHT);
  floor.addColorStop(0, '#2a1f18');
  floor.addColorStop(1, '#0a0805');
  ctx.fillStyle = floor;
  ctx.fillRect(0, 440, LOGICAL_WIDTH, LOGICAL_HEIGHT - 440);
  // Brazier glow.
  const grad = ctx.createRadialGradient(LOGICAL_WIDTH * 0.5, 470, 4, LOGICAL_WIDTH * 0.5, 470, 130);
  grad.addColorStop(0, 'rgba(255, 140, 60, 0.35)');
  grad.addColorStop(1, 'rgba(255, 140, 60, 0)');
  ctx.fillStyle = grad;
  ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
}

function drawCrypt(ctx: CanvasRenderingContext2D): void {
  const sky = ctx.createLinearGradient(0, 0, 0, LOGICAL_HEIGHT);
  sky.addColorStop(0, '#070a14');
  sky.addColorStop(0.6, '#101a26');
  sky.addColorStop(1, '#080a10');
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, LOGICAL_WIDTH, LOGICAL_HEIGHT);
  // Pillars
  ctx.fillStyle = '#0a0d14';
  for (let i = 0; i < 3; i++) {
    const x = 30 + i * 140;
    ctx.fillRect(x, 0, 28, 460);
  }
  // Floor
  ctx.fillStyle = '#0e1218';
  ctx.fillRect(0, 470, LOGICAL_WIDTH, LOGICAL_HEIGHT - 470);
  // Spectral mist
  ctx.fillStyle = 'rgba(120, 180, 200, 0.05)';
  ctx.fillRect(0, 380, LOGICAL_WIDTH, 90);
}

function drawHorizon(ctx: CanvasRenderingContext2D, y: number): void {
  ctx.fillStyle = '#080604';
  ctx.fillRect(0, y, LOGICAL_WIDTH, LOGICAL_HEIGHT - y);
}
